import { TinyMCEEvent } from './event.interface';
import { isTokenElement } from '../utils';

const TOGGLE_FORMAT_EVENT = 'mceToggleFormat';

export const isToggleFormatEvent = (element: HTMLElement, event: TinyMCEEvent): boolean => {
  return isTokenElement(element) && event.command === TOGGLE_FORMAT_EVENT;
};
